import {Component, Input} from '@angular/core';
import {FileInfoDto} from '../../../../../Models/Rrhh/Folders/file-info.interface';

@Component({
  selector: 'app-file-info-item',
  templateUrl: './file-info-item.component.html',
  styleUrls: ['./file-info-item.component.scss'],
  standalone: false
})
export class FileInfoItemComponent {
  @Input() info!: FileInfoDto;
}
